/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';
import { EntityTypeEnum } from './entityTypeEnum';


export interface PreUpgradeValidateRequestSpec { 
    service_type: ServiceTypeEnum;
    entity_type: EntityTypeEnum;
    /**
     * List of entity id\'s
     */
    ids: Array<string>;
    /**
     * Source release version number
     */
    source_release?: string;
    /**
     * Target release version number
     */
    target_release: string;
}
export namespace PreUpgradeValidateRequestSpec {
}


